// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"354":"24a5ed76a2736d07588e","418":"c583cc24546a63132603","661":"9deb7800f7b0fd1deb86"}[chunkId] + ".chunk.js";
};